// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Combinators = require("../Data.Argonaut.Decode.Combinators/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Combinators = require("../Data.Argonaut.Encode.Combinators/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Lens_Prism = require("../Data.Lens.Prism/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Set = require("../Data.Set/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Editor_Class_Depends = require("../Lunarbox.Data.Editor.Class.Depends/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Node_PinLocation = require("../Lunarbox.Data.Editor.Node.PinLocation/index.js");
var Lunarbox_Data_Editor_NodeGroup = require("../Lunarbox.Data.Editor.NodeGroup/index.js");
var NativeFunction = (function () {
    function NativeFunction(value0) {
        this.value0 = value0;
    };
    NativeFunction.create = function (value0) {
        return new NativeFunction(value0);
    };
    return NativeFunction;
})();
var VisualFunction = (function () {
    function VisualFunction(value0) {
        this.value0 = value0;
    };
    VisualFunction.create = function (value0) {
        return new VisualFunction(value0);
    };
    return VisualFunction;
})();
var encodeJsonDataflowFunction = new Data_Argonaut_Encode_Class.EncodeJson(function (v) {
    if (v instanceof VisualFunction) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJBoolean)("visual")(true))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Lunarbox_Data_Editor_NodeGroup.encodeJsonNodeGroup)("function")(v.value0))(Data_Argonaut_Core.jsonEmptyObject));
    };
    if (v instanceof NativeFunction) {
        return Data_Argonaut_Core.jsonEmptyObject;
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.DataflowFunction (line 25, column 1 - line 27, column 59): " + [ v.constructor.name ]);
});
var dependencyDataflowFunction = new Lunarbox_Data_Editor_Class_Depends.Depends(function (v) {
    if (v instanceof NativeFunction) {
        return Data_Monoid.mempty(Data_Set.monoidSet(Lunarbox_Data_Editor_FunctionName.ordFunctionName));
    };
    if (v instanceof VisualFunction) {
        return Lunarbox_Data_Editor_Class_Depends.getDependencies(Lunarbox_Data_Editor_NodeGroup.dependencyNodeGroup)(v.value0);
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.DataflowFunction (line 35, column 1 - line 37, column 57): " + [ v.constructor.name ]);
});
var decodeJsonDataflowFunction = new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson))(json))(function (obj) {
        return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Lunarbox_Data_Editor_NodeGroup.decodeJsonNodeGroup)(obj)("function"))(function (nodeGroup) {
            return Control_Applicative.pure(Data_Either.applicativeEither)(new VisualFunction(nodeGroup));
        });
    });
});
var compileDataflowFunction = function (v) {
    if (v instanceof NativeFunction) {
        return new Lunarbox_Data_Dataflow_Expression.Native(Lunarbox_Data_Editor_Node_PinLocation.InsideNative.value, v.value0);
    };
    if (v instanceof VisualFunction) {
        return Lunarbox_Data_Editor_NodeGroup.compileNodeGroup(v.value0);
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.DataflowFunction (line 40, column 27 - line 42, column 41): " + [ v.constructor.name ]);
};
var _VisualFunction = function (dictChoice) {
    return Data_Lens_Prism["prism'"](VisualFunction.create)(function (v) {
        if (v instanceof VisualFunction) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    })(dictChoice);
};
var _NativeFunction = function (dictChoice) {
    return Data_Lens_Prism["prism'"](NativeFunction.create)(function (v) {
        if (v instanceof NativeFunction) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    })(dictChoice);
};
module.exports = {
    NativeFunction: NativeFunction,
    VisualFunction: VisualFunction,
    compileDataflowFunction: compileDataflowFunction,
    "_VisualFunction": _VisualFunction,
    "_NativeFunction": _NativeFunction,
    encodeJsonDataflowFunction: encodeJsonDataflowFunction,
    decodeJsonDataflowFunction: decodeJsonDataflowFunction,
    dependencyDataflowFunction: dependencyDataflowFunction
};
